/**
 * Non-user-facing chart keys and styling literals for ForecastCard (Recharts data keys / visibility toggles).
 */

export const FORECAST_LINE_VISIBILITY = {
  estimates: 'estimates',
  reported: 'reported',
  previousYear: 'previousYear',
} as const;

export type ForecastLineVisibilityKey =
  (typeof FORECAST_LINE_VISIBILITY)[keyof typeof FORECAST_LINE_VISIBILITY];

// Minimal palette (formerly from the removed MUI md-theme colors)
export const FORECAST_CARD_COLORS = {
  success: { main: '#84cc16' },
  black: { main: '#000000' },
  grey: {
    400: '#a8a29e',
    500: '#78716c',
    600: '#57534e',
  } as Record<number, string>,
};

export const colors = FORECAST_CARD_COLORS;

/** Fallback stroke when theme grey token is missing */
export const PREVIOUS_YEAR_PREDICTION_GRAY = '#6B7280';

/** Dashed stroke pattern for previous-year series */
export const PREVIOUS_YEAR_STROKE_DASH = '5 5';
